import { RenderFunc } from '../types/RenderFunc';
import { KnmHistoryOperationsEnum } from '../../../APIPackage/KnmModule/enums/KnmHistoryOperationsEnum';

export const renderRequirements: RenderFunc = item => {
  const { newValue, oldValue, operation } = item;
  const valuesText = operation === KnmHistoryOperationsEnum.DELETE ? `"${oldValue}"` : undefined;

  return {
    renderedOldValue: `${oldValue}`,
    renderedNewValue: `${newValue}`,
    renderedValuesText: valuesText,
  };
};
